import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { SharingPanel } from '@/components/SharingPanel';

interface MobileSharingPanelProps {
  spaceId: string;
  spaceName: string;
  isOpen: boolean;
  onClose: () => void;
  isOwner: boolean;
}

export const MobileSharingPanel = ({ spaceId, spaceName, isOpen, onClose, isOwner }: MobileSharingPanelProps) => {
  return (
    <Drawer open={isOpen} onOpenChange={onClose}>
      <DrawerContent className="max-h-[90vh] min-h-[50vh]">
        <DrawerHeader className="pb-2 border-b">
          <DrawerTitle className="text-center">Share Workspace</DrawerTitle>
          <DrawerDescription className="text-center text-sm">
            Collaborate with others on "{spaceName}"
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 overflow-y-auto">
          <div className="p-4">
            <SharingPanel
              spaceId={spaceId}
              spaceName={spaceName}
              isOpen={true}
              onClose={() => {}}
              isOwner={isOwner}
            />
          </div>
        </div>
        <div className="border-t p-4">
          <Button onClick={onClose} className="w-full">
            Done
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};